import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/app/[locale]/error.tsx");
